import { useContext } from 'react';

import Modal, { COLOR_SCHEME_WHITE } from 'components/common/modals/Modal';
import ModalNoFocus from 'components/common/modals/ModalNoFocus';
import { CustomerReportContext } from 'components/grace/Contexts';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

const ModalSwitcher = ({
  showIcon, // start props for both modals
  title,
  onDismiss,
  bodyPadding,
  bodyStyle,
  topBarStyle,
  children,
  navigationHeader,
  childrenContainerClassnames,
  shouldShowHeader = true,
  explicitBodyStyle, // start props for ModalNoFocus only (web)
  explicitTopBarStyle,
  explicitMainContentClass,
  mainContentClass,
  containerStyle, // start props for Modal only (mobile web)
  renderModalInCenter,
  contentClassname,
  transitionRef,
  useMinHeight = false,
}) => {
  const { customerReport } = useContext(CustomerReportContext);
  const { isMobile } = useScreenSizeConstants();

  const showHeader = customerReport || shouldShowHeader;

  const renderWeb = () => {
    return (
      <ModalNoFocus
        showIcon={showIcon}
        title={title}
        onDismiss={onDismiss}
        bodyPadding={bodyPadding}
        bodyStyle={bodyStyle}
        explicitBodyStyle={explicitBodyStyle}
        topBarStyle={topBarStyle}
        explicitTopBarStyle={explicitTopBarStyle}
        mainContentClass={mainContentClass}
        explicitMainContentClass={explicitMainContentClass}
        mainContentRef={transitionRef}
      >
        {showHeader && navigationHeader}
        <div className={childrenContainerClassnames}>{children}</div>
      </ModalNoFocus>
    );
  };

  const renderMobileWeb = () => {
    return (
      <Modal
        showIcon={showIcon}
        title={title}
        onDismiss={onDismiss}
        bodyPadding={bodyPadding}
        bodyStyle={bodyStyle}
        topBarStyle={topBarStyle}
        colorScheme={COLOR_SCHEME_WHITE}
        containerStyle={containerStyle}
        renderModalInCenter={renderModalInCenter}
        contentClassname={contentClassname}
        containerRef={transitionRef}
        useMinHeight={useMinHeight}
      >
        {showHeader && navigationHeader}
        <div className={childrenContainerClassnames}>{children}</div>
      </Modal>
    );
  };

  return <>{isMobile ? renderMobileWeb() : renderWeb()}</>;
};

ModalSwitcher.propTypes = {
  showIcon: PropTypes.bool,
  title: PropTypes.string,
  onDismiss: PropTypes.func,
  bodyPadding: PropTypes.string,
  bodyStyle: PropTypes.string,
  topBarStyle: PropTypes.string,
  children: PropTypes.node,
  navigationHeader: PropTypes.node,
  childrenContainerClassnames: PropTypes.string,
  shouldShowHeader: PropTypes.bool,
  explicitBodyStyle: PropTypes.bool,
  explicitTopBarStyle: PropTypes.bool,
  explicitMainContentClass: PropTypes.bool,
  mainContentClass: PropTypes.string,
  containerStyle: PropTypes.string,
  renderModalInCenter: PropTypes.bool,
  contentClassname: PropTypes.string,
  transitionRef: PropTypes.object,
  useMinHeight: PropTypes.bool,
};

export default ModalSwitcher;
